export { Obstacle };
class Obstacle {
    constructor({ points }) {
        this.points = points;
    }
}
//# sourceMappingURL=Obstacle.js.map